<script>
import axios from "axios";

import AdminFormPreview from "@/components/notecatcher/admins/AdminFormPreview.vue";
import store from "@/store/index";

const apiBase = API_APP_PATH + "/v1";

export default {
  data() {
    return {
      forms: []
    };
  },
  created() {
    store.commit('currentPage', 'goalSetting')

    const DBN = store.state.admin.schools
      ? store.state.admin.schools[0].SchoolDBN
      : store.state.dbn;

    axios
      .get(`${apiBase}/data/school/goalSetting/admin/${DBN}`)
      .then(result => {
        this.forms = result.data.sort((f1, f2) => {
          let f1_open = new Date(f1.OpenWindow).getTime();
          let f2_open = new Date(f2.OpenWindow).getTime();
          if (f1_open < f2_open) return 1;
          if (f1_open > f2_open) return -1;
          return 0;
        });
      })
      .catch(e => {
        throw new Error(e);
      });
  },
  components: {
    AdminFormPreview
  }
};
</script>

<template>
  <div class="admin-landing">
    <div class="welcome-note">
      <img src="@/assets/images/assignment.png" alt="assignment">
      <p>The Mid Year Reflection form can serve as a helpful tool for teachers and administrators in understanding how best to support Advance observations in the months ahead.</p>
    </div>
    <h3>
      Use the responses in these forms to help deepen the Mid Year Conversations you have with teachers at your school and encourage them to complete the form on their end. Consider ways to use the responses to focus the conversation on areas they grew, where they want to grow, and what kinds of support were most effective. You can view the responses either as a summary or as individuals.
      <a
        href="https://nycdoe.sharepoint.com/:b:/s/GrowthExplorer/Eab3I3PIaepCm2ASindHFX4B3xsJJUgN9lwWXXkhZWy0Eg?e=3eBVl8"
        target="_blank"
      >Click here</a> for a how to guide on reading responses to the professional goal setting forms.
    </h3>
    <h3 style="text-decoration: underline; font-size: 2em;">All forms</h3>
    <div id="all-form-container">
      <AdminFormPreview v-for="form in forms" :key="form.FormId" :form="form" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.welcome-note {
    display: flex;
    align-items: center;
    font-family: Arial;
    color: #333333;
    padding: 1em;
    border: 2px solid #c4c4c4;
    border-radius: 8px;
    p {
      font-size: 1.25em;  
    }
    img {
      margin-right: 30px;
      width: 30px;
      height: 33px
    }
  }
.admin-landing {
  font-family: Arial, Helvetica, sans-serif;
  @media all and (min-width: 650px) {
      min-height: 500px;
  }
}
#all-form-container {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
</style>